module.exports = __webpack_public_path__ + "static/img/PBAE.7005fbec.png";